<template>
  <div :class="['ms-form', 'ms-form--narrow', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onModalChange">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomInput label="Старая цена" type="number" :controls="true" :value="this.formData.price_old"
          @change_input="(value) => onChange('price_old', value)" required="true" :allowNegative="true" />
        <CustomInput label="Новая цена" type="number" :controls="true" :value="this.formData.price_new"
          @change_input="(value) => onChange('price_new', value)" required="true" :allowNegative="true" />
        <CustomInput label="Разница" type="number" :controls="true" :value="this.formData.price_diff"
          @change_input="(value) => onChange('price_diff', value)" required="true" :allowNegative="true" />
      </div>
      <CustomModalFooter :btn-loading="this.btnLoading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomInput from "@/components/form/CustomInput";
import {
  getMaterialPriceData,
} from '@/views/ClientRequests/remontDS/dsCreationTemplates/changeTextConstructor/services'

export default {
  name: "text-constructor-material-price-change",
  components: { CustomCheckbox, CustomModalFooter, CustomInput },
  props: ['data'],
  data() {
    return {
      loading: false,
      btnLoading: false,
      formData: {
        client_request_id: this.data?.body?.client_request_id || '',
        tk_change_id: this.data?.body?.row.tk_change_id || '',
        price_old: '',
        price_new: '',
        price_diff: '',
      },
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value;
    },
    async getData(client_request_id, tk_change_id) {
      this.loading = true      
      const res = await getMaterialPriceData(client_request_id, tk_change_id);
      if (res) {
        this.formData.price_old = res.price_old || "";
        this.formData.price_new = res.price_new || "";
        this.formData.price_diff = res.price_diff || "";
      }
      this.loading = false
    },
    async onModalChange() {
      this.btnLoading = true
      await this.data?.onModalChange(this.formData)
      this.btnLoading = false
    },
  },
  mounted() {
    this.getData(this.formData.client_request_id, this.formData.tk_change_id)
  }
}
</script>